import { DocumentType } from 'constants/document';

export function documentMask(
  value: string,
  type?: DocumentType | null,
): string {
  const onlyNumbers = value.replaceAll(/\D/g, '');

  if (!type) {
    return onlyNumbers;
  }

  if (type === 'CPF') {
    return onlyNumbers
      .slice(0, 11)
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2');
  }

  if (type === 'CNPJ') {
    return onlyNumbers
      .slice(0, 14)
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return onlyNumbers;
}
